module.exports = __webpack_public_path__ + "static/FY_2022_Announcement_Financial_Results-742b62d556c608d6b37d7e237d86aaf9.pdf";